import { render } from "./LanguagePicker.vue?vue&type=template&id=026bf4b0&scoped=true&lang=pug"
import script from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"

import "./LanguagePicker.vue?vue&type=style&index=0&id=026bf4b0&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026bf4b0"]])

export default __exports__